module.exports = __webpack_public_path__ + "static/media/gear.d89c7240.svg";